import { Routes } from '@angular/router';

import { UserActivityComponent } from './user-activity/user-activity.component';
import { FollowersOfUserComponent } from './followers-of-user/followers-of-user.component';
import { FollowingOfUsersComponent } from './following-of-users/following-of-users.component';
import { PaymentHistoryComponent } from '../user/payment-history/payment-history.component';
import { MyPackageComponent } from '../user/my-package/my-package.component';
import { MyDownloadsComponent } from '../user/my-downloads/my-downloads.component';

export const DASHBOARD_TAB_ROUTES: Routes = [
    { path: '', redirectTo: 'user-activities', pathMatch: 'full' },
    { path: 'user-activities', component: UserActivityComponent },
    { path: 'followers', component: FollowersOfUserComponent },
    { path: 'following', component: FollowingOfUsersComponent },
    { path: 'payment-history', component: PaymentHistoryComponent },
    { path: 'my-packages', component: MyPackageComponent },
    { path: 'my-downloads', component: MyDownloadsComponent },
];



// WEBPACK FOOTER //
// ./src/app/dashboard/tab-routes.ts